module.exports = __webpack_public_path__ + "img/GAME_GLACIER2.0de5cf4c.jpg";